 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d":"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d","grupa":"grupa","korisnik~rezultati":"korisnik~rezultati","korisnik":"korisnik","rezultati":"rezultati","kreirajgrupu":"kreirajgrupu","kreirajligu":"kreirajligu","mojegrupe":"mojegrupe","mojelige":"mojelige","natjecatelji":"natjecatelji","pitanje":"pitanje","rezultatisingle":"rezultatisingle","search":"search","home":"home","login":"login","onboardingguide":"onboardingguide","onboarding~prijavapitanja~probnaprijavapitanja":"onboarding~prijavapitanja~probnaprijavapitanja","onboarding":"onboarding","prijavapitanja~probnaprijavapitanja":"prijavapitanja~probnaprijavapitanja","prijavapitanja":"prijavapitanja","probnaprijavapitanja":"probnaprijavapitanja","pravila":"pravila","probnopitanje":"probnopitanje","uredajobavijest":"uredajobavijest"}[chunkId]||chunkId) + "." + {"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d":"8e7ae93f","grupa":"0b4ddd56","korisnik~rezultati":"e2678eb4","korisnik":"f8a1abd0","rezultati":"b88860ac","kreirajgrupu":"53671f66","kreirajligu":"30ea93fa","mojegrupe":"8346cca5","mojelige":"8a333980","natjecatelji":"3dc13b2e","pitanje":"965d36dd","rezultatisingle":"1c88fc6c","search":"c4fcaa5c","home":"8a15cef4","login":"646ff79c","onboardingguide":"82de6a43","onboarding~prijavapitanja~probnaprijavapitanja":"4fb97ac3","onboarding":"88ec0576","prijavapitanja~probnaprijavapitanja":"ea7f2a20","prijavapitanja":"03a102c8","probnaprijavapitanja":"b2d5b731","pravila":"67d3fd71","probnopitanje":"8c07ea0c","uredajobavijest":"ea3e8465"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d":1,"grupa":1,"korisnik~rezultati":1,"korisnik":1,"rezultati":1,"kreirajgrupu":1,"kreirajligu":1,"mojegrupe":1,"mojelige":1,"natjecatelji":1,"pitanje":1,"rezultatisingle":1,"search":1,"home":1,"login":1,"onboardingguide":1,"onboarding~prijavapitanja~probnaprijavapitanja":1,"onboarding":1,"prijavapitanja~probnaprijavapitanja":1,"prijavapitanja":1,"probnaprijavapitanja":1,"pravila":1,"probnopitanje":1,"uredajobavijest":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d":"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d","grupa":"grupa","korisnik~rezultati":"korisnik~rezultati","korisnik":"korisnik","rezultati":"rezultati","kreirajgrupu":"kreirajgrupu","kreirajligu":"kreirajligu","mojegrupe":"mojegrupe","mojelige":"mojelige","natjecatelji":"natjecatelji","pitanje":"pitanje","rezultatisingle":"rezultatisingle","search":"search","home":"home","login":"login","onboardingguide":"onboardingguide","onboarding~prijavapitanja~probnaprijavapitanja":"onboarding~prijavapitanja~probnaprijavapitanja","onboarding":"onboarding","prijavapitanja~probnaprijavapitanja":"prijavapitanja~probnaprijavapitanja","prijavapitanja":"prijavapitanja","probnaprijavapitanja":"probnaprijavapitanja","pravila":"pravila","probnopitanje":"probnopitanje","uredajobavijest":"uredajobavijest"}[chunkId]||chunkId) + "." + {"grupa~korisnik~kreirajgrupu~kreirajligu~mojegrupe~mojelige~natjecatelji~pitanje~rezultati~rezultatis~ff9e850d":"1773f2f1","grupa":"9bdf2544","korisnik~rezultati":"6c9ee4fa","korisnik":"74d43915","rezultati":"ef3581b7","kreirajgrupu":"e94e0f2d","kreirajligu":"4ef47286","mojegrupe":"04a26e31","mojelige":"e11e330d","natjecatelji":"7a11a981","pitanje":"d30adf3d","rezultatisingle":"32865674","search":"b6bfdb24","home":"3f942768","login":"e32bf7ed","onboardingguide":"da5a6798","onboarding~prijavapitanja~probnaprijavapitanja":"5a8ac8e0","onboarding":"dcc2d91a","prijavapitanja~probnaprijavapitanja":"6cd73343","prijavapitanja":"9bc229e7","probnaprijavapitanja":"8e02a24d","pravila":"70300c8f","probnopitanje":"1590310f","uredajobavijest":"00ee7860"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/liga/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
